import type { OTRuleFormValues } from "./OTRuleForm";

/** Sample form data for auto-fill on OT Rule create page. */
export const otRuleFormSamples: OTRuleFormValues[] = [
  {
    name: "OT ວັນທຳມະດາ 1.5x",
    dayType: "weekday",
    rateMultiplier: 1.5,
    effectiveFrom: "2025-01-01",
    effectiveTo: "",
    isActive: true,
    description: "ຕາມກົດໝາຍແຮງງານ ວັນຈັນ–ສຸກ.",
  },
  {
    name: "OT ວັນພັກ 2x",
    dayType: "holiday",
    rateMultiplier: 2,
    effectiveFrom: "2025-01-01",
    effectiveTo: "",
    isActive: true,
    description: "ວັນພັກຕາມປະຕິທິນ ອັດຕາ 2 ເທົ່າ.",
  },
  {
    name: "OT ວັນທຳມະດາ ພິເສດ",
    dayType: "weekday",
    rateMultiplier: 1.75,
    effectiveFrom: "2025-06-01",
    effectiveTo: "2025-12-31",
    isActive: true,
    description: "ໄລຍະທົດລອງ ສຳລັບໂຄງການດັ່ງເດີມ.",
  },
  {
    name: "OT ວັນພັກ ສະເພາະ",
    dayType: "holiday",
    rateMultiplier: 2.5,
    effectiveFrom: "2025-01-01",
    effectiveTo: "",
    isActive: false,
    description: "ບໍ່ໃຊ້ງານຊົ່ວຄາວ ເປີດໃນກໍລະນີພິເສດ.",
  },
];
